<div *ngIf="subTitleSegments" class="flex-g-s">
  <i class="fa-sharp fa-light fa-diagram-subtask fa-2x mg-l-s mg-r-s"></i>
  <span *ngFor="let segment of getBreadcrumb(); let last = last" class="mat-headline-6 mg-r-s"> {{ segment }} {{ last ? '' : '|' }}</span>
</div>
